import React, { Component } from 'react';
import { toggleIsLoading } from 'Redux/actions/ViewStateActions';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { HeadContainer, InputCol, LevelRowContainer, MainWrapper, RoundedWrapper } from './styles';
import { withRouter } from 'react-router';
import { withTheme } from 'styled-components';
import { Label } from 'components/atoms/Texts/TxtLabel';
import { getLookup } from 'Redux/actions/LookupActions';
import FormTxt from 'components/atoms/Inputs/FormTxt';
import FormSelect from 'components/atoms/Inputs/FormSelect';
import { BARGE_LOADING, BARGE_LOADING_HEADER } from 'fixtures/api';

export class ActualLoadingWaterLevelWeatherForm extends Component {

  componentDidMount(){
    this.fetchLookup()
  }

  fetchLookup = () => {
    toggleIsLoading(true)
    const { getLookup} = this.props
    getLookup(BARGE_LOADING, BARGE_LOADING_HEADER)
    toggleIsLoading(false)
  }

  onChange(field, val) {
    const { form: { waterLevelWeather }, onChange } = this.props
    waterLevelWeather[field] = val
    onChange('waterLevelWeather', waterLevelWeather)
  }

  renderTextInput(label, key, placeholder, inputProps) {
    const { form: { waterLevelWeather }, theme } = this.props
    const inputConfig = {
      border: theme.mocaGrey,
      rad: '6px',
      width: '100%',
      yxPadding: '9px 12px',
      height: '34px',
      marginBottom: '16px'
    }

    return (
      <InputCol>
        <Label lineheight={'14px'} size={'12px'}>
          {label}
        </Label>
        <FormTxt
          placeholder={placeholder}
          mb={'16px'}
          value={waterLevelWeather ? waterLevelWeather[key] : 0}
          onChangeVal={e => this.onChange(key, e.target.value)}
          {...inputConfig}
          {...inputProps}
        />
      </InputCol>
    )
  }

  renderPicker(label, key, placeholder, options, ...rest){
    const { form: { waterLevelWeather }, theme } = this.props
    const inputConfig = {
      border: theme.mocaGrey,
      rad: '6px',
      width: '100%',
      yxPadding: '9px 12px',
      height: '34px',
      marginBottom: '16px'
    }
    return (
      <InputCol>
        <Label lineheight={'14px'} size={'12px'}>
          {label}
        </Label>
        <FormSelect
          placeholder={placeholder}
          onChangeVal={e => this.onChange(key, e.target.value)}
          options={options}
          value={waterLevelWeather ? waterLevelWeather[key] : '-'}
          valField={'name'}
          dispField={'name'}
          arrowSize={'3%'}
          {...inputConfig}
          {...rest}
        />
      </InputCol>
    )
  }

  render() {
    const { lookups } = this.props

    return (
        <RoundedWrapper gap="20px">
          <MainWrapper>
            <HeadContainer>
              <Label lineheight={'29px'} size={'16px'} mb={'0px'}>
                Water Level & Weather
              </Label>
            </HeadContainer>
              <LevelRowContainer isTop>
                {this.renderTextInput('Water Level Today', 'waterLevelToday', 'Enter water level today' )}
                {this.renderPicker('Weather', 'weather', 'Select', lookups.weatherConditions || [] )}
              </LevelRowContainer>
          </MainWrapper>
        </RoundedWrapper>
    )
  }
}

const mapStateToProps = (state) => {
  let lookups = {}
  if (state.lookups.data && state.lookups.data.BARGE_LOADING) {
    const bargeLoading = state.lookups.data.BARGE_LOADING
    const weatherConditions = bargeLoading.BARGE_LOADING_HEADER && bargeLoading.BARGE_LOADING_HEADER.find((d) => d.name === 'WEATHER_CONDITION')
    lookups.weatherConditions = weatherConditions
      ? weatherConditions.children.map((d) => ({ name: d.nameDisplay }))
      : []
  }
  return {
    viewState: state.viewState,
    lookups,
  }
}

const mapDispatchToProps = dispatch =>
  bindActionCreators(
    {
      toggleIsLoading,
      getLookup
    },
    dispatch
  )

export default withRouter(
  withTheme(
    connect(
      mapStateToProps,
      mapDispatchToProps
    )(ActualLoadingWaterLevelWeatherForm)
  )
);
